module.exports = __webpack_public_path__ + "img/1280x720-Meeting.b38002b8.jpg";